var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v(" "+_vm._s(_vm.stateSync)+" "),_c('LoginModal'),_c('router-view'),_c('GlobalToast'),(_vm.showGlobalSpinner)?_c('div',{staticClass:"global-route-loader"},[_c('Spinner')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }